
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import VideoDescription from './components/VideoDescription/VideoDescription';
import VideoDescriptionMultiplayer from './components/VideoDescriptionMultiplayer/VideoDescriptionMultiplayer';
import Screenshots from './components/Screenshots/Screenshots';
import ScreenshotsMultiplayer from './components/ScreenshotsMultiplayer/ScreenshotsMultiplayer';
import Ratings from './components/Ratings/Ratings';
import BuyItMeow from './components/BuyItMeow/BuyitMeow';
import Footer from './components/Footer/Footer';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { initGA, logPageView } from './analytics';
import Buttons from './components/Buttons/Buttons';

function App() {
  useEffect(() => {
    initGA();
  }, []);

  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return (
    
      <>
      <Header />
      <Hero />
      <Buttons/>
      <VideoDescription />
      <Screenshots />
      <VideoDescriptionMultiplayer />
      <ScreenshotsMultiplayer />
      <Ratings />
      <BuyItMeow />
      <Footer />
    </>
    
  );
}

export default App;
